import React from "react";
import styles from "./index.module.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

export default function TvRemotePrivatepolicy() {
	return (
		<>
			<Header />
			<div className={styles["container-A"]}>
				<div className={styles["container"]}>
					<div className={styles["title"]}>
						<h1>Starnest JSC Company Privacy</h1>
					</div>
					<div className={styles["content"]}>
						<p>
							<b>We respect and value your privacy here at Starnest JSC Company.</b>	
						</p>
						<p>
							Our Privacy Policy describes the information collected by our
							Starnest JSC Company, and our partners, through our mobile
							applications and the use of the information.
						</p>
						<p>
							What third parties collect via our Games or Apps
							<br />
							We receive some information automatically when you use our Games
							or Apps. This includes data about your device, software, operating
							system, the language you’ve set for your Device, advertising IDs
							for advertisement tracking (“Advertising IDs”) and your IP
							address.
						</p>
						<p>
							We collect personal information that you voluntarily provide to us
							(for example, the email you sign in to the app, the email address
							you give us when you submit your web or email support request.
							we).
						</p>
						<p>We do not share or sell your data to any third parties.</p>
						<p>We do not use data from Google Workspace APIs to improve or train any general AI and/or ML models.</p>
						<p>
							When you make in-app purchases in the our Games or Apps, we do not
							collect or have any access to your name and billing information.
							This information is collected and stored by your platform
							(Android’s Google Play) or your platform’s payment processor.
						</p>
						<p>
							Few of our Games or Apps might use Google Analytics (third party
							scripts) that collect the following information and might (also)
							store such information as a cookie on the device you use to access
							our Games or Apps.
							<br />
							<br />
							<b>Google Analytics:</b>
							<br />
							Demographics (browser language, country, city);
							<br />
							System information (browser, OS, service provider);
							<br />
							Mobile (OS, service provider, screen resolution);
							<br />
							Site behaviour (which pages users visit, duration of visit);
						</p>
						<p>
							For more information about our partners’ practices, please visit
							the following links:
							<br />
							<a href="https://policies.google.com/privacy">
								https://policies.google.com/privacy
							</a>
						</p>
						<p>
							How we use this information collected in our Games or Apps
							<br />
							We collect this Information to improve performance and reliability
							of our Games or Apps and to get a better understanding of what
							users in general prefer. We do not link any of this Information in
							any way to individuals or any other information we might obtain.
							We do not share, sell or in any other way give other persons or
							companies. We don’t rent or sell your email address.
						</p>
						<p>
							<br />
							<b>Google Drive Access</b>
							<br />
							TV Remote: Universal Remote requests read-only access to Google
							Drive only after the user explicitly grants permission.
							<br />
							Google Drive files are accessed solely to allow users to:
							<br />
							- Browse files stored in their Google Drive.
							<br />
							- Select supported files to cast.
							<br />
							- Open files selected by the user.
							<br />
							- Cast selected content to a connected TV.
							<br />
							The application does not modify, upload, delete, or share any files stored in Google Drive.
							<br />
							Google Drive files are processed only on the user&apos;s device and are never uploaded to our servers.
							<br />
							Google Drive data is never used for advertising, marketing,
							analytics, or profiling.
						</p>
						<p>
							<br />
							<b>Data Protection</b>
							<br />
							We protect Google user data using industry-standard security
							measures.
							<br />
							- All communication with Google APIs is encrypted using HTTPS/TLS.
							<br />
							- OAuth access tokens are securely stored and used only for
							authenticating requests to Google services.
							<br />
							- Access to Google Drive files is limited to the permissions
							explicitly granted by the user.
							<br />
							- We do not sell, rent, or disclose Google user data to third
							parties.
							<br />
							- Google Drive data is used only for the features requested by the
							user within the application.
						</p>
							<br />
						<p>
							<b>Google User Data Retention and Deletion</b>
							<br />
							TV Remote: Universal Remote does not permanently store Google
							Drive files on our servers.
							<br />
							Google Drive files are accessed only while the user is using the
							application to browse, select, or cast content.
							<br />
							Temporary cached files may be stored locally on the user&apos;s
							device solely to improve performance. These cached files are
							automatically removed when no longer needed or can be deleted by
							clearing the application&apos;s storage or uninstalling the
							application.
							<br />
							Users may revoke the application&apos;s access to their Google
							Account at any time through Google&apos;s Security Settings.
							<br />
							We do not store Google Drive files or Google user data on our servers. Files are accessed only to provide the requested functionality (such as browsing, selecting, or casting) and are processed locally on the user&apos;s device. Users can remove locally stored data at any time by clearing the application&apos;s data or uninstalling the application.
														<br />

						</p>
							<br />
						<p>
							<b>Google API Services User Data Policy</b>
							<br />
							TV Remote: Universal Remote&apos;s use and transfer of
							information received from Google APIs complies with the Google API
							Services User Data Policy, including the Limited Use requirements.
							<br />
							Google user data is used solely to provide the user-facing features explicitly requested by the user.
							<br />
							We do not use Google user data to develop, improve, or train generalized AI or machine learning models.
							<br />
							We do not use Google user data for advertising, marketing, or
							profiling purposes.
						</p>
							<br />
						<p>
							<b>Changes to this privacy policy</b>
							<br />
							Starnest JSC Company has the discretion to update this privacy
							policy at any time. When we do, we will revise the updated date at
							the bottom of this page. We encourage Users to frequently check
							this page for any changes to stay informed about how we are
							helping to protect the personal information we collect. You
							acknowledge and agree that it is your responsibility to review
							this privacy policy periodically and become aware of
							modifications.
						</p>
						<p>
							<b>Contacting us</b>
							<br />
							If you have any questions about this Privacy Policy, the practices
							of this site, or your dealings with our Apps, please contact us
							at:
							<br />
							<a href="mailto:?subject=StartNest QA&body=Question...">
								{" "}
								ngocttbstarnest@gmail.com
							</a>
						</p>
						<p>Last Updated Date : 24/07/2026</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}
